import React from "react";
import styled from "@emotion/styled";
import { ICommand, theme } from "Application";
import { Box, Label } from "Components";

export const Container = styled.div`
    padding: 25px 20px;
`;

export const Footer = styled.div``;

export const ButtonGroup = styled.div`
    padding: 30px 0 0;
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px 30px;
    Button {
        width: 100%;
        margin-bottom: 0;
        height: 40px;
        border-radius: 5px;
    }
`;

export const StyledDialog = styled.dialog`
    max-width: 400px;
    width: calc(100% - 50px);
    padding: 0;
    background: ${theme.palette.common.white};
    box-shadow: 0 0 5px rgba(101, 110, 119, 0.2);
    border: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 100;
    transform: translate(-50%, -50%);
    &:focus {
        border: none;
        outline: none;
    }

    &::backdrop {
        background: rgba(224, 228, 232, 0.9);
        animation: 0.4s ease fade;
    }

    &[open] {
        animation: 0.2s linear slidein;
    }

    @keyframes slidein {
        from {
            transform: translate3d(0, 5px, 0) translate(-50%, -50%);
        }
        to {
            transfrom: translate3d(0, 0, 0) translate(-50%, -50%);
        }
    }

    @keyframes fade {
        from {
            opacity: 0.3;
        }
        to {
            opacity: 1;
        }
    }

    @media only screen and (max-width: 600px) {
        width: 90%;
        z-index: 999999;
        overflow: auto;
        max-height: 96vh;
    }
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fcd21d;
    padding: 12px 20px;
    font: normal normal bold 18px/24px Open Sans;
    letter-spacing: 0px;
    color: #000000;
    font-family: OpenSans-CondBold;
    button {
        width: auto !important;
        height: auto !important;
        min-height: auto;
    }
`;

export const ListItemBox = styled(Box)`
    grid-template-columns: 1fr 1fr;
    gap: 22px 12px;
    display: grid;
    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 15px;
    }
`;

export const ListItem = styled(Box)`
    label:first-child {
        margin-bottom: 4px;
    }
    &.fullGrid {
        grid-column-start: 1;
        grid-column-end: 3;
        @media only screen and (max-width: 768px) {
            grid-column-end: 2;
        }
    }
`;

const StyledActionButton = styled.button<{ $hasAbsence?: boolean }>`
    height: 30px;
    border-radius: 5px;
    letter-spacing: 0px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 17px;
    font-family: OpenSans-CondBold;
    border: none;
    width: 100%;
    display: block;
    box-sizing: border-box;
    padding: 6px 30px;
    cursor: pointer;
    background-color: ${({ $hasAbsence }) => ($hasAbsence ? "#dc3545" : "#fcd21d")};
    color: ${({ $hasAbsence }) => ($hasAbsence ? "#ffffff" : "#000000")};
`;

interface ActionButtonProps {
    command: ICommand;
    commandParam?: any;
    $hasAbsence?: boolean;
    children: React.ReactNode;
}

export const ViewStudentDetailsButton: React.FC<ActionButtonProps> = ({ command, commandParam, children }) => (
    <StyledActionButton onClick={() => command.execute(commandParam)}>{children}</StyledActionButton>
);

export const SessionReportButton: React.FC<ActionButtonProps> = ({ command, commandParam, $hasAbsence, children }) => (
    <StyledActionButton $hasAbsence={$hasAbsence} onClick={() => command.execute(commandParam)}>
        {children}
    </StyledActionButton>
);

export const AttendanceStatusLabel = styled(Label)<{ $attended?: boolean | null }>`
    text-transform: none;
    min-height: 16px;
    color: ${({ $attended }) => ($attended ? "#27E6A3" : "#E6054E")};
`;

export const IncidentLabel = styled(Label)`
    font-style: italic;
    text-transform: uppercase;
    color: #e6054e;
    min-height: 16px;
`;

export const SessionStatusColourLabel = styled(Label)<{ $color?: string }>`
    margin-bottom: 4px;
    ${({ $color }) => $color && `color: ${$color};`}
`;

export const MentorNameLabel = styled(Label)`
    text-decoration: underline;
`;
